import { Layout } from '../components/Layout';
import { EmailOTPLoginForm } from '../components/EmailOTPLoginForm';

export const EmailOTPLogin = () => {
  return (
    <Layout title="Email OTP Required">
      <EmailOTPLoginForm />
    </Layout>
  );
};
